import styled from "styled-components";
import { FaQuoteLeft } from "react-icons/fa";

const Wrapper = styled.div`
  display:flex;
  flex-direction: column;
  gap:20px;
`;

const Quote = styled.span`
  display: inline-block;
  font-size: 2rem;
  font-family: Handlee;
  color: ${props => props.theme.color};
  transition: all 0.75s ease-out;
  text-align:center;
  svg {
    margin-right:15px;
  }
`;

const Author = styled(Quote)`
  align-self: flex-end;
  font-size: 1.2rem;
  font-family: Nunito;
`;

const QuoteBox = ({ currentQuote }) => {
  return (
    <Wrapper>
      <Quote>{currentQuote.quote && <FaQuoteLeft />}{currentQuote.quote}</Quote>
      <Author>{currentQuote.author && `-`} {currentQuote.author}</Author>
    </Wrapper>
  );
};

export default QuoteBox;